// Import all components here
import Dashboard from './university/Dashboard/Dashboard';
import Professors from './university/Professors/Professors';
import Staff from './university/Staff/Staff';

import Departments from './university/Departments/Departments';
import Courses from './university/Courses/Courses';
import CourseDetails from './university/Courses/CourseDetails'; 
import Library from './university/Library/Library';
import Holiday from './university/Holiday/Holiday';
import Calendar from './university/Calendar/Calendar';
import ChatApp from './university/ChatApp/ChatApp';
import Contact from './university/Contact/Contact';
import FileManager from './university/FileManager/FileManager';
import Payments from './admin/Payments/Payments';
import Noticeboard from './admin/Noticeboard/Noticeboard';
import Taskboard from './admin/Taskboard/Taskboard';
import Hostel from './admin/Hostel/Hostel';
import Attandance from './admin/Attandance/Attandance';
import Leave from './admin/Leave/Leave';
import Setting from './admin/Setting/Setting';
import SocialMedia from './university/SocialMedia/SocialMedia';
import Email from './university/Email/Email';
import EmailView from './university/Email/EmailView';
import Compose from './university/Email/Compose';
import PageSearch from './university/Page/PageSearch';
import PageProfile from './university/Page/PageProfile';
import PageInvoices from './university/Page/PageInvoices';
import PagePricing from './university/Page/PagePricing';
import PageTimeline from './university/Page/PageTimeline';
import PageEmpty from './university/Page/PageEmpty';
import OurCentre from './university/OurCentre/OurCentre';
import Gallery from './university/Gallery/Gallery';
import Login from './Authentication/login';
import Signup from './Authentication/signup';
import ForgotPassword from './Authentication/forgotpassword';
import NotFound from './Authentication/404';
import InternalServer from './Authentication/500';

import CatalogoCobro from './admin/CatalogoCobro/CatalogoCobro';
import CatalogoCobroDetailContainer from './admin/CatalogoCobro/CatalogoCobroDetailContainer';
import CatalogoCobroEditContainer from './admin/CatalogoCobro/CatalogoCobroEditContainer';
import CreateCatalogoCobroContainer from './admin/CatalogoCobro/CreateCatalogoCobroContainer';
import CatalogoCobroDeleteContainer from './admin/CatalogoCobro/CatalogoCobroDeleteContainer';
import CatalogoCobroVigenteContainer from './admin/CatalogoCobro/CatalogoCobroVigenteContainer';

import ComboBoxSearch from './university/Students/ComboBoxSearch';


import ReglaNegocio from './admin/ReglaNegocio/ReglaNegocio';
import ReglaNegocioDetailContainer from './admin/ReglaNegocio/ReglaNegocioDetailContainer';
import ReglaNegocioEditContainer from './admin/ReglaNegocio/ReglaNegocioEditContainer';
import ReglaNegocioCreateContainer from './admin/ReglaNegocio/ReglaNegocioCreateContainer';
import ReglaNegocioDeleteContainer from './admin/ReglaNegocio/ReglaNegocioDeleteContainer';


import Tutor from './university/Tutor/Tutor';
import TutorDetailContainer from './university/Tutor/TutorDetailContainer';
import TutorEditContainer from './university/Tutor/TutorEditContainer';
import TutorCreateContainer from './university/Tutor/TutorCreateContainer';
import TutorDeleteContainer from './university/Tutor/TutorDeleteContainer';

import AltaExpressContainer from './university/Tutor/AltaExpressContainer';
import AltaAlumnoExpressContainer from './university/Students/AltaAlumnoExpressContainer';



import Alumno from './university/Students/Alumno'
import AlumnoDetailContainer from './university/Students/AlumnoDetailContainer';
import AlumnoEditContainer from './university/Students/AlumnoEditContainer';
import AlumnoCobroContainer from './university/Students/AlumnoCobroContainer';
import AlumnoCobroContainerH from './university/Students/AlumnoCobroContainerH';
import AlumnoCobroServicioContainer from './university/Students/AlumnoCobroServicioContainer';
import AlumnoCreateContainer from './university/Students/AlumnoCreateContainer';
import AlumnoDeleteContainer from './university/Students/AlumnoDeleteContainer';




import AlumnoEnPagos from './university/Students/AlumnoEnPagos'
import AlumnoEnPagosCobroContainer from './university/Students/AlumnoEnPagosCobroContainer';
import AlumnoEnPagosCobroServicioContainer from './university/Students/AlumnoEnPagosCobroServicioContainer';


import CorteCaja from './university/Students/CorteCaja'

import CorteCajaR from './university/Students/CorteCajaR'

//import Order from './Order';

import OrderContainer from './Order/OrderContainer';
import ReglasColegiaturaDetalle from './Order/ReglasColegiaturaDetalle';
import CancelarReciboContainer from './Order/CancelarReciboContainer';


import HistorialPagoContainer from './Order/HistorialPagoContainer';

import Becas from './admin/Becas/Becas';
import ReglasAutorizadas from './admin/ReglasAutorizadas/ReglasAutorizadas';
import ServiciosAlumno from './admin/ServiciosAlumno/ServiciosAlumno';
import Colegiaturas from './admin/Colegiaturas/Colegiaturas';

import GastoCorriente from './admin/Payments/GastoCorriente';

import GCDeleteContainer from './admin/Payments/GCDeleteContainer';

import GCCreateContainer from './admin/Payments/GCCreateContainer';


import AlumnosInscritosSiguienteCicloContainer from './university/Students/AlumnosInscritosSiguienteCicloContainer'

const Routes = [
    {
        path: "/alumnossiguienteciclo",
        name: 'alumnossiguienteciclo',
        exact: true,
        pageTitle: "Alumnos Siguiente Ciclo",
        component: AlumnosInscritosSiguienteCicloContainer
    },
    {
        path: "/historialpago",
        name: 'historialpago',
        exact: true,
        pageTitle: "Historial Pagos",
        component: HistorialPagoContainer
    },
    {
        path: "/gastocorriente",
        name: 'gastocorriente',
        exact: true,
        pageTitle: "Gasto",
        component: GastoCorriente
    },
    {
        path: "/borrargastocorriente/:id",
        name: 'borrargastocorriente',
        exact: true,
        pageTitle: "Borrar ",
        component: GCDeleteContainer
    },
    {
        path: "/creargastocorriente",
        name: 'creargastocorriente',
        exact: true,
        pageTitle: "Crear Gasto Corriente",
        component: GCCreateContainer
    },
    {
        path: "/gallery",
        name: 'gallery',
        exact: true,
        pageTitle: "Gallery",
        component: Gallery
    },
    {
        path: "/ourCentre",
        name: 'ourCentre',
        exact: true,
        pageTitle: "OurCentre",
        component: OurCentre
    },
    {
        path: "/pageEmpty",
        name: 'pageEmpty',
        exact: true,
        pageTitle: "PageEmpty",
        component: PageEmpty
    },
    {
        path: "/pageTimeline",
        name: 'pageTimeline',
        exact: true,
        pageTitle: "PageTimeline",
        component: PageTimeline
    },
    {
        path: "/pagePricing",
        name: 'pagePricing',
        exact: true,
        pageTitle: "PagePricing",
        component: PagePricing
    },
    {
        path: "/pageInvoices",
        name: 'pageInvoices',
        exact: true,
        pageTitle: "PageInvoices",
        component: PageInvoices
    },
    {
        path: "/pageProfile",
        name: 'pageProfile',
        exact: true,
        pageTitle: "PageProfile",
        component: PageProfile
    },
    {
        path: "/pageSearch",
        name: 'pageSearch',
        exact: true,
        pageTitle: "PageSearch",
        component: PageSearch
    },
    {
        path: "/compose",
        name: 'compose',
        exact: true,
        pageTitle: "Compose",
        component: Compose
    },
    {
        path: "/emailView",
        name: 'emailView',
        exact: true,
        pageTitle: "EmailView",
        component: EmailView
    },
    {
        path: "/email",
        name: 'email',
        exact: true,
        pageTitle: "Email",
        component: Email
    },
    {
        path: "/socialMedia",
        name: 'socialMedia',
        exact: true,
        pageTitle: "socialMedia",
        component: SocialMedia
    },
    {
        path: "/setting",
        name: 'setting',
        exact: true,
        pageTitle: "setting",
        component: Setting
    },
    {
        path: "/leave",
        name: 'leave',
        exact: true,
        pageTitle: "leave",
        component: Leave
    },
    {
        path: "/attandance",
        name: 'attandance',
        exact: true,
        pageTitle: "attandance",
        component: Attandance
    },
    {
        path: "/hostel",
        name: 'hostel',
        exact: true,
        pageTitle: "hostel",
        component: Hostel
    },
    {
        path: "/taskboard",
        name: 'taskboard',
        exact: true,
        pageTitle: "taskboard",
        component: Taskboard
    },
    {
        path: "/noticeboard",
        name: 'noticeboard',
        exact: true,
        pageTitle: "noticeboard",
        component: Noticeboard
    },
    {
        path: "/payments",
        name: 'payments',
        exact: true,
        pageTitle: "Payments",
        component: Payments
    },
    {
        path: "/filemanager",
        name: 'filemanager',
        exact: true,
        pageTitle: "FileManager",
        component: FileManager
    },
    {
        path: "/contact",
        name: 'contact',
        exact: true,
        pageTitle: "Contact",
        component: Contact
    },
    {
        path: "/chat",
        name: 'chatApp',
        exact: true,
        pageTitle: "ChatApp",
        component: ChatApp
    },
    {
        path: "/events",
        name: 'calendar',
        exact: true,
        pageTitle: "Calendar",
        component: Calendar
    },
    {
        path: "/holiday",
        name: 'holiday',
        exact: true,
        pageTitle: "Holiday",
        component: Holiday
    },
    {
        path: "/library",
        name: 'library',
        exact: true,
        pageTitle: "Library",
        component: Library
    },
    {
        path: "/courses",
        name: 'courses',
        exact: true,
        pageTitle: "Courses",
        component: Courses
    },
    {
        path: "/courseDetails",
        name: 'courseDetails',
        exact: true,
        pageTitle: "CourseDetails",
        component: CourseDetails
    },
    {
        path: "/departments",
        name: 'departments',
        exact: true,
        pageTitle: "Departments",
        component: Departments
    },
    {
        path: "/cortecaja",
        name: 'cortecaja',
        exact: true,
        pageTitle: "Corte Caja",
        component: CorteCaja
    },
    {
        path: "/cortecajar",
        name: 'cortecajar',
        exact: true,
        pageTitle: "Corte Caja Resumen",
        component: CorteCajaR
    },
    {
        path: "/staff",
        name: 'staff',
        exact: true,
        pageTitle: "Staff",
        component: Staff
    },
    {
        path: "/professors",
        name: 'professors',
        exact: true,
        pageTitle: "Professors",
        component: Professors
    },
    
    {
        path: "/login",
        name: 'login',
        exact: true,
        pageTitle: "Tables",
        component: Login
    },
    {
        path: "/signup",
        name: 'signup',
        exact: true,
        pageTitle: "Tables",
        component: Signup
    },
    {
        path: "/forgotpassword",
        name: 'forgotpassword',
        exact: true,
        pageTitle: "Tables",
        component: ForgotPassword
    },
    {
        path: "/notfound",
        name: 'notfound',
        exact: true,
        pageTitle: "Tables",
        component: NotFound
    },
    {
        path: "/internalserver",
        name: 'internalserver',
        exact: true,
        pageTitle: "Tables",
        component: InternalServer
    },
    {
        path: "/servicios",
        name: 'servicios',
        exact: true,
        pageTitle: "Servicios",
        component: CatalogoCobro
    },
    {
        path: "/serviciosalumno",
        name: 'serviciosalumno',
        exact: true,
        pageTitle: "Servicios Alumno",
        component: ServiciosAlumno
    },
    {
        path: "/detallecatalogocobro/:id",
        name: 'detallecatalogocobro',
        exact: true,
        pageTitle: "Detalle Catalogo Cobro",
        component: CatalogoCobroDetailContainer
    },
    {
        path: "/editarcatalogocobro/:id",
        name: 'editarcatalogocobro',
        exact: true,
        pageTitle: "Editar Catalogo Cobro",
        component: CatalogoCobroEditContainer
    },
    {
        path: "/crearcatalogocobro",
        name: 'crearcatalogocobro',
        exact: true,
        pageTitle: "Crear Catalogo Cobro",
        component: CreateCatalogoCobroContainer
    },
    {
        path: "/borrarcatalogocobro/:id",
        name: 'borrarcatalogocobro',
        exact: true,
        pageTitle: "Borrar Catalogo Cobro",
        component: CatalogoCobroDeleteContainer
    },
    {
        path: "/activarcatalogocobro/:id",
        name: 'activarcatalogocobro',
        exact: true,
        pageTitle: "Activar catalogo",
        component: CatalogoCobroVigenteContainer
    },
    {
        path: "/comboboxsearch",
        name: 'comboboxsearch',
        exact: true,
        pageTitle: "Ejemplo Busqueda",
        component: ComboBoxSearch
    },
    {
    path: "/reglasestablecidas",
        name: 'reglasestablecidas',
        exact: true,
        pageTitle: "Regla Negocio",
        component: ReglaNegocio
    },
    {
        path: "/detallereglanegocio/:id",
        name: 'detallereglanegocio',
        exact: true,
        pageTitle: "Detalle Regla Negocio",
        component: ReglaNegocioDetailContainer
    },
    {
    path: "/editarreglanegocio/:id",
        name: 'editarreglanegocio',
        exact: true,
        pageTitle: "Editar Regla Negocio",
        component: ReglaNegocioEditContainer
    },
    {
    path: "/crearreglanegocio",
        name: 'crearreglanegocio',
        exact: true,
        pageTitle: "Crear Regla Negocio",
        component: ReglaNegocioCreateContainer
    },
    {
    path: "/borrarreglanegocio/:id",
        name: 'borrarreglanegocio',
        exact: true,
        pageTitle: "Borrar Regla Negocio",
        component: ReglaNegocioDeleteContainer
    },
    {
        path: "/tutor",
        name: 'tutor',
        exact: true,
        pageTitle: "Tutor",
        component: Tutor
    },
    {
        path: "/altaexpress",
        name: 'altaexpress',
        exact: true,
        pageTitle: "Alta Express",
        component: AltaExpressContainer
    },

    {
        path: "/detalletutor/:id",
        name: 'detalletutor',
        exact: true,
        pageTitle: "Detalle Tutor",
        component: TutorDetailContainer
    },
    {
        path: "/editartutor/:id",
        name: 'editartutor',
        exact: true,
        pageTitle: "Editar Tutor",
        component: TutorEditContainer
    },
    {
        path: "/creartutor",
        name: 'creartutor',
        exact: true,
        pageTitle: "Crear Tutor",
        component: TutorCreateContainer
    },
    {
        path: "/borrartutor/:id",
        name: 'borrartutor',
        exact: true,
        pageTitle: "Borrar Tutor",
        component: TutorDeleteContainer
    },
    {
        path: "/alumno",
        name: 'alumno',
        exact: true,
        pageTitle: "Alumno",
        component: Alumno
    },
    {
        path: "/alumnoenpagos",
        name: 'alumnoenpagos',
        exact: true,
        pageTitle: "Alumno",
        component: AlumnoEnPagos
    },
    {
        path: "/cancelarrecibo/:id",
        name: 'cancelarrecibo',
        exact: true,
        pageTitle: "Cancelar Recibo",
        component: CancelarReciboContainer
    },

    {
        path: "/detallealumno/:id",
        name: 'detallealumno',
        exact: true,
        pageTitle: "Detalle Alumno",
        component: AlumnoDetailContainer
    },
    {
        path: "/editaralumno/:id",
        name: 'editaralumno',
        exact: true,
        pageTitle: "Editar Alumno",
        component: AlumnoEditContainer
    },
    {
        path: "/cobroalumno/:id",
        name: 'cobroalumno',
        exact: true,
        pageTitle: "Cobro Alumno",
        component: AlumnoCobroContainer
    },
    {
        path: "/alumnocarrito/:id",
        name: 'alumnocarrito',
        exact: true,
        pageTitle: "Alumno Carrito",
        component: OrderContainer
    },
    {
        path: "/alumnoreglas/:id/:ciclo",
        name: 'alumnoreglas',
        exact: true,
        pageTitle: "Validación Reglas Colegiatura",
        component: ReglasColegiaturaDetalle
    },
    {
        path: "/cobroalumnoh/:id",
        name: 'cobroalumnoh',
        exact: true,
        pageTitle: "Cobro Alumno Ciclo anterior",
        component: AlumnoCobroContainerH
    },
    {
        path: "/cobroenpagosalumno/:id",
        name: 'cobroenpagosalumno',
        exact: true,
        pageTitle: "Cobro En Pagos Alumno",
        component: AlumnoEnPagosCobroContainer
    },
    {
        path: "/cobroservicioalumno/:id",
        name: 'cobroservicioalumno',
        exact: true,
        pageTitle: "Cobro Servicio Alumno",
        component: AlumnoCobroServicioContainer
    },
    {
        path: "/cobroenpagosservicioalumno/:id",
        name: 'cobroenpagosservicioalumno',
        exact: true,
        pageTitle: "Cobro En Pagos Servicio Alumno",
        component: AlumnoEnPagosCobroServicioContainer
    },
    {
        path: "/crearalumno",
        name: 'crearalumno',
        exact: true,
        pageTitle: "Crear Alumno",
        component: AlumnoCreateContainer
    },
    {
        path: "/alumnoexpress",
        name: 'alumnoexpress',
        exact: true,
        pageTitle: "Alta Alumno",
        component: AltaAlumnoExpressContainer
    },
    {
        path: "/borraralumno/:id",
        name: 'borraralumno',
        exact: true,
        pageTitle: "Borrar Alumno",
        component: AlumnoDeleteContainer
    },
    {
        path: "/becas",
        name: 'becas',
        exact: true,
        pageTitle: "Listado De Becas",
        component: Becas
    },
    {
        path: "/reglasautorizadas",
        name: 'reglasautorizadas',
        exact: true,
        pageTitle: "Reglas Autorizadas",
        component: ReglasAutorizadas
    },
    {
        path: "/colegiaturas",
        name: 'colegiaturas',
        exact: true,
        pageTitle: "Colegiaturas",
        component: Colegiaturas
    },
    
];

/*
 {
        path: "/carrito",
        name: 'carrito',
        exact: true,
        pageTitle: "carrito",
        component: Order
    },
 {
        path: "/",
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Dashboard
    },
 */

export default Routes;